module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_zigbang_m.2b68052c202f8abaa3009d5ce692caed.png";